export default function Privatlivspolitik() {
  return (
    <div className="min-h-screen bg-white">
      <div className="mx-auto max-w-4xl px-4 py-16 sm:px-6 lg:px-8">
        <h1 className="text-4xl font-extrabold text-slate-900 mb-8">Privatlivspolitik</h1>

        <div className="prose prose-slate max-w-none">
          <p className="text-sm text-slate-600 mb-8">
            <strong>Senest opdateret:</strong> 30. oktober 2025
          </p>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-slate-900 mb-4">1. Dataansvarlig</h2>
            <p className="text-slate-700 leading-relaxed">
              Plejesøstrene ApS<br />
              CVR: 45991768<br />
              Helgavej 26, 5230 Odense M<br />
              Email: info@plejesoestrene.dk<br />
              Telefon: 89801515
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-slate-900 mb-4">2. Hvilke personoplysninger indsamler vi?</h2>
            <p className="text-slate-700 leading-relaxed mb-4">
              Vi indsamler og behandler følgende personoplysninger, når du bruger vores hjemmeside:
            </p>

            <h3 className="text-xl font-semibold text-slate-900 mb-3">Kontaktformular:</h3>
            <ul className="list-disc pl-6 text-slate-700 space-y-2 mb-4">
              <li>Navn</li>
              <li>Email-adresse</li>
              <li>Besked/henvendelse</li>
              <li>IP-adresse (teknisk nødvendig)</li>
              <li>Tidspunkt for indsendelse</li>
            </ul>

            <h3 className="text-xl font-semibold text-slate-900 mb-3">Cookies og sporingsteknologier:</h3>
            <p className="text-slate-700 leading-relaxed">
              Se vores <a href="/cookiepolitik" className="text-brand-600 hover:underline">Cookiepolitik</a> for detaljer.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-slate-900 mb-4">3. Formål og retsgrundlag</h2>
            <p className="text-slate-700 leading-relaxed mb-4">
              Vi behandler dine personoplysninger til følgende formål:
            </p>

            <div className="overflow-x-auto">
              <table className="min-w-full border border-slate-200 mb-4">
                <thead className="bg-slate-50">
                  <tr>
                    <th className="border border-slate-200 px-4 py-2 text-left">Formål</th>
                    <th className="border border-slate-200 px-4 py-2 text-left">Retsgrundlag (GDPR)</th>
                    <th className="border border-slate-200 px-4 py-2 text-left">Opbevaringstid</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className="border border-slate-200 px-4 py-2">Besvarelse af henvendelser</td>
                    <td className="border border-slate-200 px-4 py-2">Legitim interesse (Art. 6(1)(f))</td>
                    <td className="border border-slate-200 px-4 py-2">6 måneder efter afslutning</td>
                  </tr>
                  <tr>
                    <td className="border border-slate-200 px-4 py-2">Opfyldelse af kontrakt (ved ansøgning om vikarstilling)</td>
                    <td className="border border-slate-200 px-4 py-2">Kontraktopfyldelse (Art. 6(1)(b))</td>
                    <td className="border border-slate-200 px-4 py-2">5 år (jf. bogføringslov)</td>
                  </tr>
                  <tr>
                    <td className="border border-slate-200 px-4 py-2">Cookies til statistik (hvis samtykke givet)</td>
                    <td className="border border-slate-200 px-4 py-2">Samtykke (Art. 6(1)(a))</td>
                    <td className="border border-slate-200 px-4 py-2">Indtil samtykke trækkes tilbage</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-slate-900 mb-4">4. Videregivelse af data</h2>
            <p className="text-slate-700 leading-relaxed mb-4">
              Dine personoplysninger videregives til:
            </p>
            <ul className="list-disc pl-6 text-slate-700 space-y-2 mb-4">
              <li><strong>Web3Forms</strong> (email-leverandør) - anvendes til at sende kontaktformular-data som email. Web3Forms behandler data i overensstemmelse med GDPR.</li>
            </ul>

            <p className="text-slate-700 leading-relaxed mb-2">Vi videregiver IKKE dine data til:</p>
            <ul className="list-disc pl-6 text-slate-700 space-y-2">
              <li>Tredjeparter til marketingformål</li>
              <li>Lande uden for EU/EØS (medmindre passende sikkerhedsforanstaltninger er på plads)</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-slate-900 mb-4">5. Dine rettigheder</h2>
            <p className="text-slate-700 leading-relaxed mb-4">
              Du har følgende rettigheder i henhold til GDPR:
            </p>
            <ul className="list-disc pl-6 text-slate-700 space-y-2">
              <li><strong>Ret til indsigt (Art. 15)</strong> - Få information om hvilke data vi har om dig</li>
              <li><strong>Ret til berigtigelse (Art. 16)</strong> - Få rettet forkerte oplysninger</li>
              <li><strong>Ret til sletning (Art. 17)</strong> - "Retten til at blive glemt"</li>
              <li><strong>Ret til begrænsning (Art. 18)</strong> - Begrænse behandlingen af dine data</li>
              <li><strong>Ret til dataportabilitet (Art. 20)</strong> - Få dine data i maskinlæsbart format</li>
              <li><strong>Ret til indsigelse (Art. 21)</strong> - Modsætte dig behandling baseret på legitim interesse</li>
            </ul>
            <p className="text-slate-700 leading-relaxed mt-4">
              For at udøve dine rettigheder, kontakt os på <a href="mailto:info@plejesoestrene.dk" className="text-brand-600 hover:underline">info@plejesoestrene.dk</a>.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-slate-900 mb-4">6. Sikkerhed</h2>
            <p className="text-slate-700 leading-relaxed mb-4">
              Vi implementerer passende tekniske og organisatoriske sikkerhedsforanstaltninger:
            </p>
            <ul className="list-disc pl-6 text-slate-700 space-y-2">
              <li>SSL-kryptering (HTTPS) på hele hjemmesiden</li>
              <li>Adgangskontrol til systemer med persondata</li>
              <li>Regelmæssige sikkerhedsopdateringer</li>
              <li>Kryptering af data under transmission</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-slate-900 mb-4">7. Opbevaringsperioder</h2>
            <p className="text-slate-700 leading-relaxed mb-4">
              Vi opbevarer dine personoplysninger så længe det er nødvendigt til formålet:
            </p>
            <ul className="list-disc pl-6 text-slate-700 space-y-2">
              <li>Kontaktformular-henvendelser: 6 måneder efter besvarelse</li>
              <li>Ansøgermateriale: 6 måneder (eller 5 år ved ansættelse jf. bogføringslov)</li>
              <li>Cookies: Se vores <a href="/cookiepolitik" className="text-brand-600 hover:underline">cookiepolitik</a></li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-slate-900 mb-4">8. Klage til Datatilsynet</h2>
            <p className="text-slate-700 leading-relaxed mb-4">
              Hvis du mener, at vi behandler dine personoplysninger i strid med databeskyttelseslovgivningen, har du ret til at klage til:
            </p>
            <p className="text-slate-700 leading-relaxed">
              <strong>Datatilsynet</strong><br />
              Carl Jacobsens Vej 35<br />
              2500 Valby<br />
              Email: <a href="mailto:dt@datatilsynet.dk" className="text-brand-600 hover:underline">dt@datatilsynet.dk</a><br />
              Telefon: 33 19 32 00<br />
              Website: <a href="https://www.datatilsynet.dk" target="_blank" rel="noopener noreferrer" className="text-brand-600 hover:underline">www.datatilsynet.dk</a>
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-slate-900 mb-4">9. Ændringer til denne politik</h2>
            <p className="text-slate-700 leading-relaxed">
              Vi forbeholder os retten til at opdatere denne privatlivspolitik. Ændringer træder i kraft ved offentliggørelse på hjemmesiden. Vi anbefaler, at du regelmæssigt gennemlæser politikken. Seneste opdateringsdato fremgår øverst på siden.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-slate-900 mb-4">10. Kontakt</h2>
            <p className="text-slate-700 leading-relaxed">
              Har du spørgsmål til denne privatlivspolitik eller vores behandling af personoplysninger, er du velkommen til at kontakte os:
            </p>
            <p className="text-slate-700 leading-relaxed mt-4">
              Email: <a href="mailto:info@plejesoestrene.dk" className="text-brand-600 hover:underline">info@plejesoestrene.dk</a><br />
              Telefon: <a href="tel:+4589801515" className="text-brand-600 hover:underline">89801515</a>
            </p>
          </section>

          <div className="mt-12 pt-8 border-t border-slate-200">
            <p className="text-sm text-slate-600">
              Denne privatlivspolitik er udarbejdet i overensstemmelse med:
            </p>
            <ul className="list-disc pl-6 text-sm text-slate-600 space-y-1 mt-2">
              <li>Europa-Parlamentets og Rådets forordning (EU) 2016/679 (GDPR)</li>
              <li>Databeskyttelsesloven (lov nr. 502 af 23. maj 2018)</li>
            </ul>
          </div>
        </div>

        <div className="mt-12 text-center">
          <a
            href="/"
            className="btn btn-primary btn-lg"
          >
            Tilbage til hjemmesiden
          </a>
        </div>
      </div>
    </div>
  );
}
